import React from "react";

export default function IconWebCamera() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 21"
      fill="black"
      width="21px"
      height="21px">
      <path d="M12 2C7.59 2 4 5.59 4 10c0 2.38 1.19 4.49 3 5.86V18c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-2.14c1.81-1.37 3-3.48 3-5.86 0-4.41-3.59-8-8-8zm0 2c3.31 0 6 2.69 6 6 0 2.08-1.06 3.93-2.81 5-.13.08-.19.24-.19.4V17h-6v-1.6c0-.16-.07-.32-.19-.4C7.06 13.93 6 12.08 6 10c0-3.31 2.69-6 6-6zm0 3a3 3 0 100 6 3 3 0 000-6zm0 2a1 1 0 110 2 1 1 0 010-2z" />
    </svg>
  );
}
